import React from "react";
import ReactDOM from "react-dom";

export default function EntryPage({ data }) {

  return (
    // eventually pull background image from admin
    <div
      class="vh-100 vh-100-lg"
      style={{
        background:
          "url('https://s3.amazonaws.com/islandroutes.com/pjigUwo6ImUGJbPPxnxAZKvAb6inmpch2B34rGkf.jpg')",
        backgroundPosition: "top",
        backgroundSize: "cover",
        overflow: "hidden"
      }}
    >
      <div class="full-bg-img flex-center">
        <div class="container pt-8 pt-lg-0">
          <div class="row">
            <div class="col-12 m-auto">
              <div class="white-text text-center mb-4 col-md-7 col-lg-5 m-auto">
                <img
                  src="https://s3.amazonaws.com/islandroutes.com/ojuQl6L6Vg5Ap02d6U5OAzvzMcsdZ2QDyGt8KuCY.png"
                  style={{ width: "100%" }}
                  class="col-4 mx-auto fr-fil fr-dib"
                />

                <h2 class="d-none">
                  <span class="font-supersized">Discover Bahamas</span>
                </h2>
                <div class="d-none white-text pr-2 pl-2 mb-10">
                  <span class="font-larger">
                    Over 500 Tours in 13 Caribbean Destinations
                  </span>
                </div>
              </div>
              <br />
              <div class="row col-12 col-lg-6 mx-auto">
                <div class="col-12 col-lg-6 mb-2 mx-auto text-center d-inline">
                  {/* add option to customize redirect link */}
                  <a href={`/${data.redirect_url}?on_property=true`}>
                    <button class="btn btn-lg btn-rounded btn-primary py-3 px-4">
                      Already On Property
                    </button>
                  </a>
                </div>
                <div class="col-12 col-lg-6 mb-2 mx-auto text-center d-inline">
                  <a
                    class="btn btn-lg btn-rounded btn-primary py-3 px-4"
                    href={`/${data.redirect_url}?on_property=false`}
                  >
                    Not Yet On Property
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className="entry-background">
    //   <div className="row">
    //     <div className="col col-md-6">
    //       <a href='/?on_property=true'>
    //         <div className="m-auto border option-tile">
    //           <h2>On Property</h2>
    //         </div>
    //       </a>
    //     </div>
    //     <div className="col col-md-6">
    //       <a href="/?on_property=false">
    //         <div className="m-auto border option-tile">
    //           <h2>Not on Property</h2>
    //         </div>
    //       </a>
    //     </div>
    //   </div>
    // </div>
  );
}

if (document.getElementById("entryPage")) {
  const element = document.getElementById("entryPage");
  const data = Object.assign({}, element.dataset);

  // console.log("entry element", data.data);

  ReactDOM.render(
    <EntryPage data={JSON.parse(data.data)} />,
    document.getElementById("entryPage")
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/EntryPage/index.js